import { mat4 } from "_src/libs/gl-matrix";

const ST_LEO    = "Leo";
const ST_SPIDER = "Spider";
const ST_EVA    = "Eva";
const ST_MICRO  = "Micro";
const ST_RAY    = "Ray";

const CT_LUMINERA  = "luminera";
const CT_POINTGRAY = "pointgray";

const MaxPower = 3;

export default function calcTextureCorrectionMatrix(scanProperty, dest) {

  const m = scanProperty.getValue("correction");
  const colorCorrectionMatrix = mat4.set(dest, m[0], m[1], m[2], 0,
                                               m[3], m[4], m[5], 0,
                                               m[6], m[7], m[8], 0,
                                               m[9], m[10],m[11],1);
  const corrCoeff = calcTexturingCorrectionCoefficient(scanProperty);

  if (corrCoeff != -1) {
    mat4.multiplyScalar(dest, dest, corrCoeff);
  }

  return { colorCorrectionMatrix, corrCoeff };

}

function calcTexturingCorrectionCoefficient(scanProperty) {

  const scannerType = scanProperty.getValue("scannertype");
  const textureGain = scanProperty.getValue("texturegain");
  const textureCameraType = scanProperty.getValue("texturecameratype");

  const calibrationGain = scannerType === ST_LEO ? getCalibrationGainForLeo() :
      getCalibrationGainForArtecTextureCameraType(textureGain, textureCameraType);

  const textureBrightnessLevel = getBrightenssLevelForScannerType(scannerType);
  const textureIllumination = scanProperty.getValue("textureillumination");

  if (!textureIllumination)
  {
      return -1;
  }

  if (scannerType != ST_LEO)
  {
    if (!textureGain || !textureCameraType)
    {
        return -1;
    }
  }

  const distanceCorrectionCoeff = 1.0 / (textureIllumination * 1e6);

  return calibrationGain * distanceCorrectionCoeff * textureBrightnessLevel;

}

function getBrightenssLevelForScannerType(scannertype) {

  switch(scannertype) {
    case ST_SPIDER:
      return 70;
    case ST_EVA:
      return 175;
    case ST_MICRO:
      return 110;
    case ST_LEO:
      return 175;
    case ST_RAY:
      return 175;
    default:
      return 175;
  }

}

function getCalibrationGainForLeo() {
  //https://bitbucket.artec-group.com:4433/projects/AS/repos/app-astudio/browse/astudio/source/Utils/TexturingCorrectionCoefficient.cpp#17
  return 1.0;
}

function getCalibrationGainForArtecTextureCameraType(textureGain, textureCameraType) {

  const Ig =[ // Lumenera:  I(g) = k1 * g + k0
              [0.6538, 9.64, 0.0, 0.0],

              // PG Fly: I(g) = k3 * g^3 + k2 * g^2 + k1 * g + k0
              [124.99878123, 16.52975347, 1.08349533, 0.0]
            ];

  // Default gain that is used for camera callibration
  const  calibrationGain = [// Lumenera (value was estimated since no EVA's with this camera type)
                            4.0,
                            // PG Fly
                            0.0];

  const cameraTypeId = textureCameraType == CT_LUMINERA ? 0 : textureCameraType == CT_POINTGRAY ? 1 : 1;

  const g = textureGain || 1.0;
  const g0 = calibrationGain[cameraTypeId];

  let calibrationBrightnessLevel = 0.0;
  let estimatedBrightnessLevel = 0.0;

  let gPow = 1.0;
  let g0Pow = 1.0;

  for (let power = 0; power <= MaxPower; power++)
  {
      estimatedBrightnessLevel += Ig[cameraTypeId][power] * gPow;
      calibrationBrightnessLevel += Ig[cameraTypeId][power] * g0Pow;
      gPow *= g;
      g0Pow *= g0;
  }

  return calibrationBrightnessLevel / estimatedBrightnessLevel;

}
